import {number} from 'prop-types';
import {ActionType, createAction} from 'typesafe-actions';

export const requestPlayAction = createAction('REQUEST_PLAY')();
export const requestPauseAction = createAction('REQUEST_PAUSE')();
export const requestNextAction = createAction('REQUEST_NEXT')();
export const requestPreviousAction = createAction('REQUEST_PREVIOUS')();
export const requestProgressUpdateAction = createAction('REQUEST_PROGRESS_UPDATE')<number>();

export type PlayMachineActions = ActionType<typeof requestPlayAction> | ActionType<typeof requestPauseAction>;
